import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text">
          <Element type="h2" className="header-text1">{"İster ev sahibi olun, ister kiracı evinizde gerçekleşebilecek tüm risklere karşı eşya sigortası yaptırabilirsiniz. "}</Element>
          <Element type="p" className="header-text2">{"Eşya Güvence sigortası ile hırsızlık, yangın, su basması, elektronik eşya arızası gibi durumlara karşı eşyalarınız güvence altına alınırken ücretsiz kombi / klima bakımı ile hayatınız daha kolay."}</Element>
        </Block>
      </Block>
      <Image path={"./img/esyasigortasi/konut_esya_sigorta.png"} className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
